import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateRegisterDTO, CreateRegisterResponseDTO } from "./type";

export async function createRegister(
  register: CreateRegisterDTO,
): Promise<CreateRegisterResponseDTO> {
  const response = await apiClient.post<CreateRegisterResponseDTO>(
    apiPaths.registers.create,
    register,
  );
  return response.data;
}
